import React from 'react';
import './styles/style.scss';
import Article from './Article';
import ArticleItem from './ArticleItem';

export default Article;
export { default as ArticleItem } from './ArticleItem';

export const ArticleHeader = props => <ArticleItem type="header" {...props} />;
